var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"UserPicture user-picture",class:{ 'is_image': _vm.profile.image }},[_c('span',{staticClass:"user-picture__first-letter",domProps:{"textContent":_vm._s(_vm.profileFullName[0])}}),(_vm.profile.image)?_c('div',{staticClass:"img",style:(_vm.style)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }